import React, { useState } from 'react';
import FullModal from './FullModal';
import { NotebookTabs } from 'lucide-react';
import { InputTextField } from '../Input/InputTextField';
import { Button } from '@mui/material';
import { LoaderSpinner } from './LoaderSpinner';


const CreateContract = ({ invite, onClose, onCreate }) => {
  const [memberId, setMemberId] = useState('');
  const [contractDate, setContractDate] = useState('');
  const [rate, setRate] = useState('');
  const [inputStyle, setInputStyle] = useState({});
  const [loading, setLoading] = useState(false);

  const handleUpdate = (field) => (value) => {
    if (field === "memberId") {
      setMemberId(value);
    } else if (field === "contractDate") {
      setContractDate(value);
    } else if (field === "rate") {
      setRate(value);
    }
  };

  const handleCreate = async () => {
    if (memberId.trim() === '' || contractDate.trim() === '' || rate.trim() === '') {
      setInputStyle({ border: '1px solid red' });
      return;
    }

    setLoading(true);
    onCreate?.({
      id: `${memberId}-${contractDate}-${Date.now()}`,
      memberId: memberId.trim(),
      date: contractDate,
      rate: parseFloat(rate),
    });
    setLoading(false);
    onClose();
  };

  return (
    <FullModal onClose={onClose}>
        <div className="flex-row align-center">
            
            <NotebookTabs size={24} style={{ marginRight: 10, color: 'var(--brand-blue)' }} />
        </div>

        <InputTextField
            onChange={handleUpdate("memberId")}
            placeholder='Member ID / Patient ID'
            value={memberId}
            style={memberId === '' ? inputStyle : {}}
        />
        <InputTextField
            onChange={handleUpdate("contractDate")}
            type="date"
            value={contractDate}
            style={contractDate === '' ? inputStyle : {}}
        />
        <InputTextField
            onChange={handleUpdate("rate")}
            placeholder='Rate'
            inputMode="decimal"
            allowPattern={/^\d*\.?\d*$/}
            value={rate}
            style={rate === '' ? inputStyle : {}}
        />
        <div style={{width: '100%',marginTop: 16}} className="flex-row align-center">
            <Button
                variant="contained" 
                color="primary"
                onClick={handleCreate}
            >
                Create
            </Button>
            { loading && <LoaderSpinner style={{marginLeft: 20}} absolute={false} /> }
        </div>
        
    </FullModal>
  );
};

export default CreateContract;
